import React, { useContext } from 'react'
import classNames from 'classnames'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'
import useFormat from 'modules/react/loan-calculator/hooks/useFormat'
import SkeletonLine from 'modules/react/loan-calculator/content/SkeletonLine'

export default function TotalFooter() {
  const { nextStep, loanCalculationObject } = useContext(LoanCalculatorContext)
  const { loanCalculationData, loanCalculationIsLoading, loanCalculationError } = loanCalculationObject
  const { formatPrice } = useFormat()
  const buttonClassName = classNames('button default', { 'button--loading': loanCalculationIsLoading })

  const onButtonClick = () => {
    if (loanCalculationIsLoading) {
      return
    }

    nextStep()
  }

  return (
    <div className={'lc-total'}>
      <div className={'lc-total__inner'}>
        <div className={'lc-total__total'}>
          {loanCalculationIsLoading
            ? <SkeletonLine style={{ height: '30px', width: '120px' }}/>
            : formatPrice(loanCalculationData?.monthlyPrice)
          }
        </div>
        <p className={'lc-total__text'}>Forventet mdl. ydelse</p>
      </div>
      <button className={buttonClassName} onClick={onButtonClick}>
        <span>Fortsæt</span>
      </button>
    </div>
  )
}
